import React from 'react';
import { T } from 'shared/helper/translate';
var StartTrialConfirmationModal = function StartTrialConfirmationModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    onStartTrial = _ref.onStartTrial,
    loading = _ref.loading,
    isChinaUser = _ref.isChinaUser;
  if (!open) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-center",
    style: {
      position: 'fixed',
      inset: 0,
      background: 'rgba(0,0,0,0.5)',
      zIndex: 1050
    },
    role: "dialog",
    "aria-modal": "true"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-white rounded p-4 position-relative",
    style: {
      maxWidth: '420px',
      width: '90%',
      border: '1px solid #dee2e6'
    }
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn position-absolute border-0 bg-transparent p-0",
    style: {
      top: '1rem',
      right: '1rem',
      fontSize: '1.1rem',
      lineHeight: 1,
      color: 'rgb(108 117 125 / 48%)'
    },
    "aria-label": "Close",
    onClick: onClose
  }, "\xD7"), /*#__PURE__*/React.createElement("h3", {
    className: "fw-bold mb-3"
  }, /*#__PURE__*/React.createElement(T, {
    source: isChinaUser ? 'rubriq.cardless-trial-modal-title-china' : 'rubriq.cardless-trial-modal-title-row'
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-muted mb-4"
  }, /*#__PURE__*/React.createElement(T, {
    source: isChinaUser ? 'rubriq.cardless-trial-modal-description-china' : 'rubriq.cardless-trial-modal-description-row'
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn w-100 py-2 fw-bold text-white",
    style: {
      backgroundColor: '#0d6e6e',
      borderRadius: '13px'
    },
    disabled: loading,
    onClick: onStartTrial
  }, loading ? /*#__PURE__*/React.createElement(T, {
    source: "Starting..."
  }) : /*#__PURE__*/React.createElement(T, {
    source: "Start Free Trial"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-center text-muted small mt-2 mb-0"
  }, /*#__PURE__*/React.createElement(T, {
    source: isChinaUser ? 'rubriq.cardless-trial-modal-subtext-china' : 'rubriq.cardless-trial-modal-subtext'
  }))));
};
export default StartTrialConfirmationModal;